import { InputCategory } from '@api/InputCategories/InputCategory';
import InputCategoryServ from '@api/InputCategories/InputCategoryServ';

class InputCategoriesService {
    saveInputCategory = (inputCategory: InputCategory): Promise<InputCategory> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await InputCategoryServ.saveInputCategory(inputCategory);
                resolve(data);
            } catch (error) {
                reject('Error saving input category: ' + error);
            }
        });
    };
    getInputCategories = (): Promise<InputCategory[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await InputCategoryServ.getInputCategories();
                resolve(data);
            } catch (error) {
                reject('Error getting input categories: ' + error);
            }
        });
    };
    getInputCategory = (inputCategoryId: string): Promise<InputCategory> => {
        return new Promise(async (resolve, reject) => {
            try {
                const inputCategory = await InputCategoryServ.getInputCategory(inputCategoryId);
                resolve(inputCategory);
            } catch (error) {
                reject('Error getting input category: ' + error);
            }
        });
    };

    deleteInputCategory = (inputCategoryId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await InputCategoryServ.deleteInputCategory(inputCategoryId);
                resolve();
            } catch (error) {
                reject('Error deleting input category: ' + error);
            }
        });
    };
}
export default InputCategoriesService;
